module.exports = "https://preprod.web-phone.apps.phone.com/static/media/Montserrat-Medium.c8b6e083.ttf";